"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryTextSimpleOutputStreamCollector = void 0;
/**
 * An implementation of a TextSimpleOutputStream that just collects
 * all of the items into an in-memory buffer.
 *
 * The string items are appended to an in-memory buffer
 * until the stream is closed. The content of the buffer
 * can be retrieved by calling `getText()`.
 */
class InMemoryTextSimpleOutputStreamCollector {
    constructor() {
        this.buffer = '';
        this.closed = false;
    }
    emit(item) {
        if (!this.closed) {
            this.buffer += item;
        }
    }
    close() {
        this.closed = true;
    }
    isClosed() {
        return this.closed;
    }
    /**
     * Get the content of the in-memory buffer.
     *
     * @returns the content of the in-memory buffer.
     */
    getText() {
        return this.buffer;
    }
}
exports.InMemoryTextSimpleOutputStreamCollector = InMemoryTextSimpleOutputStreamCollector;
//# sourceMappingURL=stream.js.map